// extracted by mini-css-extract-plugin
module.exports = {"now-playing-animation":"now-playing-animation_now-playing-animation__pdDlQ","now-playing-animation--artist":"now-playing-animation_now-playing-animation--artist__bSj2I"};